"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISABILITY_FIELDS = void 0;
var entities_1 = require("@common/entities");
var constants_1 = require("../../constants");
exports.DISABILITY_FIELDS = [
    __assign(__assign({}, entities_1.DisabilityFields.disabled), { type: entities_1.FieldType.YesNo, customType: entities_1.FieldType.YesNo, sequence: 1, required: false, enabled: true, options: constants_1.YES_NO_OPTIONS }),
    __assign(__assign({}, entities_1.DisabilityFields.disabilityType), { type: entities_1.FieldType.ChooseManyDropdown, customType: entities_1.FieldType.ChooseManyDropdown, sequence: 2, required: false, enabled: true, options: constants_1.DISABILITY_TYPE_OPTIONS }),
];
